import types from '../actions/types';

const initialState = {
  fireOptions: [],  //"type":"RECEIVE_FIRES"
  theftOptions: [], //"type":"RECEIVE_THEFTS"
  montevideoNeighborhoods: [],
};

const cleanableState = {
  houseType: 'A',
  aptoFloors: 1,
  fireSelected: null,
  theftSelected: null,

  addressState: null,
  addressCity: null,
  addressStreet: null,
  addressNumber: '',
  
  propertyContainsGrille: true,
  propertyContainsAlarm: true,
  propertyRoofType: true,
  propertyFloorsCount: 1,
};

const home = (state = {...initialState, ...cleanableState}, action) => {
  switch (action.type) {

    case types.CLEAN:
      return { ...state, ...cleanableState};
      
    case types.SET_HOME_VALUE: {
      const { type, value } = action.payload;
      return {
        ...state,
        [type]: value
      }
    };

    default:
      return state;
  }
};

export default home;
